/**
 * The one tokenizer the search index is built with and queried with (issue #15, ADR-0008). Both
 * sides must agree, so it lives in shared/ and has no dependencies.
 */

/** Words too common to index from descriptions; names keep every token. */
export const STOPWORDS: ReadonlySet<string> = new Set([
  "a", "an", "and", "are", "as", "at", "be", "by", "for", "from", "has", "have", "if", "in", "is", "it", "its", "of", "on", "or",
  "that", "the", "this", "to", "with", "you", "your", "can", "when", "which", "while", "until", "than", "then", "into", "each",
]);

/**
 * Lower-case ASCII words: diacritics folded, apostrophes closed up ("you're" -> "youre"), every
 * other non-alphanumeric run a separator, tokens shorter than `min` dropped (the index keeps
 * two characters and up; a name's normal form keeps every character, "Necklace of Fireballs I").
 */
export function tokenize(text: string, min = 2): string[] {
  return text
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/['’]/g, "")
    .split(/[^a-z0-9]+/)
    .filter((t) => t.length >= min);
}

/** The normalised form of a name for exact and prefix comparison: every token, joined by one space. */
export function normalizeName(text: string): string {
  return tokenize(text, 1).join(" ");
}
